module.exports = __webpack_public_path__ + "static/media/Ingredients.58b5c103.png";